import { render, staticRenderFns } from "./Batchfile.vue?vue&type=template&id=0dca0f5e&scoped=true"
import script from "./Batchfile.vue?vue&type=script&lang=js"
export * from "./Batchfile.vue?vue&type=script&lang=js"
import style0 from "./Batchfile.vue?vue&type=style&index=0&id=0dca0f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca0f5e",
  null
  
)

export default component.exports